import { STRAPI_FILTER_OPERATORS } from '../../constants';
import { FilterStateValue } from '../../types/filters';

export const createBetweenFilterPart = (
  field: string,
  fromParam: FilterStateValue,
  toParam: FilterStateValue
) => {
  if (!fromParam && !toParam) {
    return null;
  }

  if (fromParam && !toParam) {
    return {
      [field]: {
        [STRAPI_FILTER_OPERATORS.GTE]: fromParam,
      },
    };
  }

  if (!fromParam && toParam) {
    return {
      [field]: {
        [STRAPI_FILTER_OPERATORS.LTE]: toParam,
      },
    };
  }

  if (fromParam && toParam) {
    return {
      [field]: {
        [STRAPI_FILTER_OPERATORS.BETWEEN]: [fromParam, toParam],
      },
    };
  }
};

export default createBetweenFilterPart;
